import {
  DiscordLogoIcon,
  EnvelopeIcon,
  GithubLogoIcon,
  LinkedinLogoIcon,
  TelegramLogoIcon,
} from "@phosphor-icons/react";

export const SOCIAL_LINKS = [
  {
    title: "Email",
    value: "macariojenmar05@gmail.com",
    path: "mailto:macariojenmar05@gmail.com",
    icon: EnvelopeIcon,
  },
  {
    title: "Telegram",
    value: "jenmarmacario",
    path: "https://t.me/jenmarmacario",
    icon: TelegramLogoIcon,
  },
  {
    title: "Discord",
    value: "jenmarmacario",
    path: "https://discord.com/users/1126704829780205588",
    icon: DiscordLogoIcon,
  },
  {
    title: "LinkedIn",
    value: "linkedin.com/in/jenmar-macario",
    path: "https://www.linkedin.com/in/jenmar-macario/",
    icon: LinkedinLogoIcon,
  },
  {
    title: "GitHub",
    value: "macariojenmar",
    path: "https://github.com/macariojenmar",
    icon: GithubLogoIcon,
  }
];
